// extracted by mini-css-extract-plugin
module.exports = {"caseSummary":"case-summary-module--case-summary--3iTh3","sectionInner":"case-summary-module--section-inner--1xiPo"};